/** Mayi Mimarlık — site geneli iletişim & local SEO bilgileri */
export const COMPANY = {
  name: "Mayi Mimarlık",
  fullName: "Mayi Mimarlık İnşaat Gıda Petrol Otomotiv Sanayi Ticaret Ltd. Şti.",
  email: "info@mayimimarlik.com",
  website: "https://mayimimarlik.com",
  phone: "05333299593",
  phoneDisplay: "+90 533 329 95 93",
  phoneTel: "+905333299593",
  whatsapp: "905333299593",
  whatsappUrl: "https://wa.me/905333299593",
  address: "Çeysa Plaza, Mezopotamya, 334. Sk. No:2A, 21070 Kayapınar/Diyarbakır",
  streetAddress: "Çeysa Plaza, Mezopotamya, 334. Sk. No:2A",
  district: "Kayapınar",
  city: "Diyarbakır",
  region: "Güneydoğu Anadolu",
  postalCode: "21070",
  country: "TR",
  geoRegion: "TR-21",
  lat: 37.9339324,
  lng: 40.1552729,
  mapsUrl: "https://maps.google.com/maps?q=37.9339324,40.1552729&hl=tr&z=15",
  mapsEmbedUrl: "https://maps.google.com/maps?q=37.9339324,40.1552729&hl=tr&z=15&output=embed",
  foundingYear: 2018,
  logoUrl: "https://mayimimarlik.com/yataylogo.svg",
  showroomImage:
    "https://firebasestorage.googleapis.com/v0/b/mayimimarlik-6dfe5.firebasestorage.app/o/mayi-mimarlik-dis-cephe.webp?alt=media&token=b54ea0d7-becb-4e5e-a52b-10fec01a04c0",
  openingHours: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "08:30",
    closes: "18:30",
  },
  /** Hizmet verilen bölgeler — local SEO & schema areaServed */
  areaServed: [
    "Diyarbakır",
    "Kayapınar",
    "Bağlar",
    "Yenişehir",
    "Sur",
    "Bismil",
    "Ergani",
    "Silvan",
    "Mardin",
    "Batman",
    "Şanlıurfa",
    "Güneydoğu Anadolu",
  ],
  brands: [
    { name: "Creavit", role: "Bölge Distribütörü", path: "/urunler", keywords: ["vitrifiye", "banyo", "klozet", "lavabo"] },
    { name: "Duratiles", role: "Ana Bayi", path: "/duratiles", keywords: ["seramik", "porselen karo", "yer karosu"] },
    { name: "QUA Granite", role: "Ana Bayi", path: "/qua", keywords: ["granit karo", "porselen", "60x120"] },
    { name: "Kalekim", role: "Ana Bayi", path: "/kalekim", keywords: ["yapı kimyasalları", "seramik yapıştırıcı", "su yalıtım"] },
    { name: "Vitra Fix", role: "Ana Bayi", path: "/vitrafix", keywords: ["yapıştırıcı harç", "derz dolgu", "epoksi"] },
  ],
} as const;

export const SITE_URL = COMPANY.website;
